import React, { useEffect } from 'react';
import {
  CircularProgress,
  Alert,
} from '@mui/material';
import { type GridColDef } from '@mui/x-data-grid';
import { DataGrid, PageTitle, ListLayoutPanel, AddButton, GridEditButton } from '../../../components/common';
import { EditProveedor } from './components';
import { type Proveedor, type ProveedorRequest } from './types/proveedor';
import { useProveedorStore } from './store';

const ProveedoresPage: React.FC = () => {
  const {
    proveedores,
    loading,
    error,
    selectedProveedor,
    dialogOpen,
    fetchProveedores,
    saveProveedor,
    setSelectedProveedor,
    openDialog,
    closeDialog,
    clearError
  } = useProveedorStore();

  const columns: GridColDef[] = [
    { field: 'idPersona', headerName: 'Código', width: 100 },
    { field: 'razonSocial', headerName: 'Razón Social', width: 250, flex: 1 },
    { field: 'identificacion', headerName: 'Identificación', width: 150 },
    { field: 'comunicacion', headerName: 'Teléfono', width: 150 },
    { field: 'asociacion', headerName: 'Asociación', width: 240 },
    {
      field: 'actions',
      headerName: '',
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <GridEditButton
          onClick={() => handleEdit(params.row.idPersona)}
          ariaLabel={`Editar proveedor ${params.row.razonSocial}`}
        />
      ),
    },
  ];

  useEffect(() => {
    fetchProveedores();
  }, [fetchProveedores]);

  const handleEdit = (idPersona: number) => {
    const proveedor = proveedores.find(p => p.idPersona === idPersona) || null;
    setSelectedProveedor(proveedor);
    openDialog();
  };

  const handleCreate = () => {
    setSelectedProveedor(null);
    openDialog();
  };

  const handleClose = () => {
    closeDialog();
  };

  const handleSave = async (updatedProveedor: ProveedorRequest) => {
    try {
      await saveProveedor(updatedProveedor);
    } catch (error) {
      console.error('Error saving proveedor:', error);
    }
  };

  if (loading) {
    return (
      <ListLayoutPanel>
        <PageTitle
          title="Proveedores"
          subtitle="Gestión de proveedores"
          actions={
            <AddButton
              text="Nuevo Proveedor"
              onClick={handleCreate}
            />
          }
        />
        <CircularProgress />
      </ListLayoutPanel>
    );
  }

  if (error) {
    return (
      <ListLayoutPanel>
        <PageTitle
          title="Proveedores"
          subtitle="Gestión de proveedores"
          actions={
            <AddButton
              text="Nuevo Proveedor"
              onClick={handleCreate}
            />
          }
        />
        <Alert
          severity="error"
          onClose={clearError}
        >
          {error}
        </Alert>
      </ListLayoutPanel>
    );
  }

  return (
    <ListLayoutPanel>
      <PageTitle
        title="Proveedores"
        subtitle="Gestión de proveedores"
        actions={
          <AddButton
            text="Nuevo Proveedor"
            onClick={handleCreate}
          />
        }
      />

      <DataGrid
        columns={columns}
        rows={proveedores}
        getRowId={(row: Proveedor) => row.idPersona}
      />

      <EditProveedor
        open={dialogOpen}
        proveedorIdPersona={selectedProveedor?.idPersona || null}
        onClose={handleClose}
        onSave={handleSave}
        title={selectedProveedor ? "Editar Proveedor" : "Nuevo Proveedor"}
      />
    </ListLayoutPanel>
  );
};

export default ProveedoresPage;